export default __webpack_public_path__ + "static/media/plumber.8a27ed1d.png";